import React from "react";

function PolicyFooter(props) {
  return (
    <div>
      © 2017 - {new Date().getFullYear()}
      <br />
      Электронная информационно-образовательная среда, Цифровой образовательный
      ресурс
      <br />
      <a target="_blank" href="https://roweb.online/personal-studio/policy.pdf">
        Политика в отношении обработки персональных данных
      </a>
      <br />
      <a
        target="_blank"
        href="https://roweb.online/personal-studio/agreement.pdf"
      >
        Пользовательское соглашение
      </a>
    </div>
  );
}

export default PolicyFooter;
